<script>
import ExternalHotelSearchBox from "./ExternalHotelSearchBox.vue";
import InternalHotelSearchBox from "./InternalHotelSearchBox.vue";
import { hotelDestinationType } from "../../../Constants";

export default {
  name: "HotelDestination",

  components: {
    ExternalHotelSearchBox,
    InternalHotelSearchBox,
  },

  data() {
    return {
      hotelDestinationType,
      isDestinationLandingPage: null,
      sectionList: [],
      activeSection: null,
      internalHotelValue:
        window?.bookingSectionInitialize?.internalHotelIsActive,
      externalHotelValue:
        window?.bookingSectionInitialize?.externalHotelIsActive,
    };
  },
  watch: {
    activeSection(newVal, oldVal) {},
  },
  computed: {
    isInternalHotelActive() {
      return (
        this.internalHotelValue &&
        this.activeSection === this.hotelDestinationType.internalHotel.value
      );
    },
    isExternalHotelActive() {
      return (
        this.externalHotelValue &&
        this.activeSection === this.hotelDestinationType.externalHotel.value
      );
    },
  },
  methods: {
    initializeSectionList() {
      this.sectionList = Object.values(this.hotelDestinationType);
    },
    setInitialActiveSection() {
      this.activeSection =
        window?.searchInitialize?.search?.destinations?.destinationType;
    },
    checkIsDestinationLandingPage() {
      this.isDestinationLandingPage =
        window?.searchInitialize?.search?.isDestinationLandingPage;
    },
  },

  created() {
    this.checkIsDestinationLandingPage();
    this.initializeSectionList();
    this.setInitialActiveSection();
  },
};
</script>
<template>
  <div>
    <ul v-if="isDestinationLandingPage" class="booking__type mb--2">
      <li
        class="booking__type-item"
        v-for="item in sectionList"
        :key="item.key"
      >
        <input
          type="radio"
          class="checkmark"
          v-model="activeSection"
          :id="item.id"
          :value="item.value"
          autocomplete="off"
          name="hotel-active-section"
        />

        <label :for="item.id"> {{ item.title }}</label>
      </li>
    </ul>
    <external-hotel-search-box v-if="isExternalHotelActive" />
    <internal-hotel-search-box v-if="isInternalHotelActive" />
  </div>
</template>
